import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-life-record-troubleshooting',
  templateUrl: './life-record-troubleshooting.component.html',
  styleUrls: ['./life-record-troubleshooting.component.scss']
})
export class LifeRecordTroubleshootingComponent implements OnInit {

  title: string = "Life Record - عوارض";
  isTroubleShhotingLifeRecord: boolean = true;
  constructor() { }

  ngOnInit() {
  }

}
